// extracted by mini-css-extract-plugin
export default {"root":"_245m0","animator":"Rqq5T","notification-link":"lVcKi","notificationLink":"lVcKi"};